import { DateTimeFactory } from "../../../../../modules/localization/useDateTime"
import { MeetingServiceOrder } from "../../../../../modules/merchant/accounting/accounting/accountingTypes"
import {
    CreateOrderDialogFlow,
    CreateOrderDialogMode,
    CreateOrderDialogType,
    CreateOrderFlowType,
} from "../../createOrderTypes"
import { DeliveryTimesField } from "./formTypes"

type MultipleDeliveriesState = {
    mode?: CreateOrderDialogMode
    dialogType: CreateOrderDialogType
    flowConfig?: CreateOrderDialogFlow
    orderDetails: MeetingServiceOrder
    dateTimeFactory: DateTimeFactory
}

export function buildMultipleDeliveriesState({
    mode,
    dialogType,
    flowConfig,
    orderDetails,
    dateTimeFactory,
}: MultipleDeliveriesState): DeliveryTimesField | null {
    const isOutlookFlow = flowConfig?.flow === CreateOrderFlowType.OUTLOOK
    if (mode === "create" && !isOutlookFlow) return null

    const meetingStartIso = orderDetails.meetingDetails?.startDateTime
    const deliveries = orderDetails.deliveries ?? []
    const useMeetingStart = isOutlookFlow && !!meetingStartIso && !deliveries.length

    const baseDateTime = useMeetingStart
        ? dateTimeFactory.fromApi(meetingStartIso!)
        : deliveries.length
        ? dateTimeFactory.fromApi(deliveries[0].deliveryTime)
        : null

    const activeTime = baseDateTime?.toFormat("HH:mm") ?? null
    const deliveryDate = mode === "duplicate" ? null : baseDateTime?.toFormat("yyyy-LL-dd") ?? null

    const deliveryTimes = useMeetingStart
        ? [
              {
                  time: baseDateTime?.toFormat("HH:mm") ?? null,
                  orderLines: [], // No order lines from meetingDetails
              },
          ]
        : deliveries.map((d) => {
              const time = dateTimeFactory.fromApi(d.deliveryTime).toFormat("HH:mm")
              const orderLines =
                  dialogType === CreateOrderDialogType.SUPPLEMENTARY_ORDER
                      ? []
                      : d.orderLines.map((l) => ({
                            id: l.productId,
                            name: l.name,
                            marketingDetails: undefined,
                            quantity: l.items,
                            isActive: true,
                            price: l.itemPrice,
                            isExtraService: false,
                            priceListId: l.priceListId,
                        }))
              return { time, orderLines }
          })

    return { activeTime, deliveryDate, deliveryTimes }
}
